
import MobileMixin from "@/mixins/mobileMixin";
import {Component} from "vue-property-decorator";

@Component
export default class KImageBanner extends MobileMixin {
}
